
<template>
    <img class="icon-banner" src="@images/portal/course-empty.svg" alt="" />
</template>
<script>
export default {
    name: "CourseProgramEmptyIcon"
}
</script>
